import React, { useState } from 'react';
import { SketchPicker } from 'react-color';
import ConfirmDialog from "components/ConfirmDialog/ConfirmDialog";

const ColorPicker = (props) => {
  const [color, setColor] = useState(props.defaultColor);

  return (
    <ConfirmDialog
      open={true}
      type="warning"
      title="Veldu lit"
      message={<SketchPicker color={color} onChange={(e) => setColor(e.hex)} />}
      onConfirm={() => props.confirm(color)}
      onCancel={() => props.onCancel()}
    />
  );
};

export default ColorPicker;